import React, { useEffect, useRef, useState } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import EditorMain from "../editor/Editor";
import PublishLoad from "../editor/PublishLoad";
import { useParams } from "react-router-dom";
import apiclient from "../../apiclient";
import { PROJECT_STATUS } from "../../apiclient/apiEndpoints";
const { useUnoSelector } = UnoStoreHooks;

const PublishProject = ({ isMobileView }) => {
  const configData = useUnoSelector((state) => state.config);
  const [progressComplete, setProgressComplete] = useState(false);
  const [progressFailed, setProgressFailed] = useState(false);
  const { uuid, versionId } = useParams();
  const timerRef = useRef(null);

  const getPublishStatus = async (versionId) => {
    try {
      let data = await apiclient.get(`${configData.config.API_URL}${PROJECT_STATUS}/${versionId}`);
      if (data.status === "COMPLETE") {
        setProgressComplete(true);
      } else if (data.status === "FAIL") {
        setProgressFailed(true);
      } else {
        timerRef.current = setTimeout(() => {
          getPublishStatus(versionId);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPublishStatus(versionId);
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [versionId]);

  return (
    <>
      <PublishLoad progressComplete={progressComplete} progressFailed={progressFailed} />
      <EditorMain isMobileView={isMobileView} showHeaderProps={false} showToolbarProps={false} />
    </>
  );
};

export default PublishProject;
